export default __webpack_public_path__ + "static/media/undervisning merged@0.25x.bfda4114.png";